import { apiClient } from './client';
import { LeaveType, LeaveBalance, LeaveRequest } from '../types/leave';

export const leaveApi = {
  types: () => apiClient.get<{ data: LeaveType[] }>('/api/leave-types'),
  myBalances: () => apiClient.get<{ data: LeaveBalance[] }>('/api/leave/my-balances'),
  myRequests: () => apiClient.get<{ data: LeaveRequest[] }>('/api/leave/my-requests'),
  apply: (input: { leaveTypeId: number; startDate: string; endDate: string; reason?: string }) =>
    apiClient.post<{ data: { id: number; daysRequested: number } }>('/api/leave/apply', input),
  pendingForSupervisor: () => apiClient.get<{ data: LeaveRequest[] }>('/api/leave/pending-supervisor-review'),
  supervisorDecide: (id: number, input: { decision: 'approved' | 'rejected'; comment?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/leave/${id}/supervisor-decide`, input),
  pendingForHR: () => apiClient.get<{ data: LeaveRequest[] }>('/api/leave/pending-hr-review'),
  listForEmployee: (employeeId: number) => apiClient.get<{ data: LeaveRequest[] }>(`/api/employees/${employeeId}/leave`),
  hrDecide: (id: number, input: { decision: 'approved' | 'rejected'; comment?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/leave/${id}/hr-decide`, input),
  supervisorReturn: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/leave/${id}/supervisor-return`, { comment }),
  hrReturn: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/leave/${id}/hr-return`, { comment }),
  resubmit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/leave/${id}/resubmit`),
};
